<ngx-extended-pdf-viewer
    zoom="page-width"
    [filenameForDownload]="filenameForDownload()"
    [forceUsingLegacyES5]="true"
    [language]="translateService.getCurrentLang()"
    [showBookModeButton]="false"
    [showDrawEditor]="false"
    [showInfiniteScrollButton]="false"
    [showOpenFileButton]="false"
    [showPrintButton]="showPrintButton()"
    [showRotateButton]="false"
    [showStampEditor]="false"
    [showTextEditor]="false"
    [src]="src()"
    [textLayer]="true"
    (pageChange)="$event === this.pagesCount ? scrolledToBottom.emit() : null"
    (pagesLoaded)="onPageLoaded($event.pagesCount)"
/>
